import {
    GET_CHARGEBACK_MONITORING_LIST_SUCCESS,
    GET_CHARGEBACK_MONITORING_SEARCH_SUCCESS,
    CHARGEBACK_MONITORING_API_ERROR
} from "./actionTypes"

const INIT_STATE = {
    recordList: [],
    error: {}
}

const chargebackMonitoring = (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_CHARGEBACK_MONITORING_LIST_SUCCESS:
        case GET_CHARGEBACK_MONITORING_SEARCH_SUCCESS:
            return {
                ...state,
                recordList: action.payload,
            }
        case CHARGEBACK_MONITORING_API_ERROR:
            return {
                ...state,
                error: action.payload,
                loading: false
            }
        default:
            return state
    }
}

export default chargebackMonitoring